module.exports = __webpack_public_path__ + "static/media/riskFactors.743cf5ea.mp3";